import { onLoaded } from "@/utils"

const LICENSE_ENDPOINT = 'https://arraystory.com/'

// Global license status
let licenseStatus = {
    isValid: false,
    isChecking: false
}

// Prevent multiple initializations
let licenseInitialized = false

/**
 * Check if license is active
 */
export const isLicenseActive = () => {
    const license = ajaxpress_vars?.license || {}
    return !!(license.key && license.status === 'active')
}

/**
 * Get current license validation status
 */
export const getLicenseStatus = () => {
    return licenseStatus
}

const License = () => {
    // Prevent re-initialization
    if (licenseInitialized) {
        return
    }

    let license = null

    onLoaded(() => {
        // Prevent re-initialization
        if (licenseInitialized) {
            return
        }

        // Mark as initialized
        licenseInitialized = true

        license = ajaxpress_vars.license || {}
        
        // Set initial license status
        licenseStatus.isValid = isLicenseActive()

        if (!license.key || license.status !== 'active') {
            return
        }

        checkLicenseValidity()
    })

    const checkLicenseValidity = async () => {
        let lastCheck = null
        const now = Date.now()
        const twelveHoursInMs = 12 * 60 * 60 * 1000

        // Try to get last check from localStorage with error handling
        try {
            lastCheck = localStorage.getItem('ajaxpress_license_last_check')
        } catch (error) {
            console.warn('AjaxPress: localStorage not available')
        }

        if (lastCheck && (now - parseInt(lastCheck)) < twelveHoursInMs) {
            return
        }

        if (!navigator.onLine) {
            return
        }

        licenseStatus.isChecking = true

        try {
            const url = `${LICENSE_ENDPOINT}?license&action=check`
            const siteHost = new URL(ajaxpress_vars.site.url).host

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    product: 'ajaxpress',
                    license_key: license.key,
                    site_url: siteHost
                })
            })

            const data = await response.json()

            if (data.success && data.valid) {
                try {
                    localStorage.setItem('ajaxpress_license_last_check', now.toString())
                } catch (error) {
                    console.warn('AjaxPress: Failed to save license check timestamp')
                }
                licenseStatus.isValid = true
            } else {
                console.warn('AjaxPress: License validation failed')
                licenseStatus.isValid = false
            }
        } catch (error) {
            console.warn('AjaxPress: License check failed (network error)')
            // On network error, keep current status
        } finally {
            licenseStatus.isChecking = false
        }
    }
}

export default License
